<template>
	<div class="hris-page">
		<div class="hris-page-inner">
			<div class="hris-page-header">
				<span class="hris-page-eyebrow">Employee Management</span>
				<h1 class="hris-page-title">Dashboard</h1>
				<p class="hris-page-subtitle">Overview of workforce headcount, growth, and distribution.</p>
			</div>

			<div class="hris-grid" style="margin-bottom: 20px;">
				<div class="hris-stat-card">
					<p class="hris-stat-label">Active Employees</p>
					<p class="hris-stat-value">{{ totalActive }}</p>
				</div>
				<div class="hris-stat-card">
					<p class="hris-stat-label">New Employees This Month</p>
					<p class="hris-stat-value">{{ totalNew }}</p>
				</div>
				<div class="hris-stat-card">
					<p class="hris-stat-label">Active Companies</p>
					<p class="hris-stat-value">{{ totalActiveCompanies }}</p>
				</div>
			</div>

			<div class="row q-col-gutter-md">
				<div class="col-12 col-lg-8">
					<div class="hris-panel">
						<p class="hris-panel-title">Employee Statistics</p>
						<apexchart width="100%" height="300px" type="line" :options="linechartOptions"
							:series="lineseries"></apexchart>
						<q-tooltip anchor="bottom middle" self="bottom middle" :offset="[10, 10]">
							<strong>Total Number of Employee Monthly</strong>
						</q-tooltip>
					</div>
				</div>
				<div class="col-12 col-lg-4">
					<div class="hris-panel">
						<p class="hris-panel-title">Department Statistics</p>
						<template v-if="hasDeptChartData">
							<apexchart width="100%" height="313px" type="pie" :options="pieDeptChartOptions"
								:series="pieDeptSeries"></apexchart>
						</template>
						<div v-else class="hris-empty" style="height: 313px;">
							No department data available.
						</div>
						<q-tooltip anchor="bottom middle" self="bottom middle" :offset="[10, 10]">
							<strong>Total Number of Employee per Department</strong>
						</q-tooltip>
					</div>
				</div>
			</div>
			<div class="row q-col-gutter-md">
				<div class="col-12 col-lg-8">
					<div class="hris-panel">
						<p class="hris-panel-title">Account Statistics (Monthly)</p>
						<template v-if="hasAccountAreaData">
							<apexchart width="100%" height="300px" type="area" :options="barchartOptions"
								:series="barseries"></apexchart>
						</template>
						<div v-else class="hris-empty" style="height: 300px;">
							No account data available.
						</div>
						<q-tooltip anchor="bottom middle" self="bottom middle" :offset="[10, 10]">
							<strong>Total Number of Employee per Account Monthly</strong>
						</q-tooltip>
					</div>
				</div>
				<div class="col-12 col-lg-4">
					<div class="hris-panel">
						<p class="hris-panel-title">Account Statistics</p>
						<template v-if="hasAccountPieData">
							<apexchart width="100%" height="313px" type="pie" :options="pieChartOptions"
								:series="pieSeries"></apexchart>
						</template>
						<div v-else class="hris-empty" style="height: 313px;">
							No account data available.
						</div>
						<q-tooltip anchor="bottom middle" self="bottom middle" :offset="[10, 10]">
							<strong>Total Number of Employee per Account</strong>
						</q-tooltip>
					</div>
				</div>
			</div>
			<q-dialog v-model="spinner" persistent>
				<div class="hris-loading" style="background: var(--hris-surface); border-radius: var(--hris-radius); padding: 32px 40px;">
					<q-spinner color="green" size="3em"></q-spinner>
					<div>Loading dashboard...</div>
				</div>
			</q-dialog>
		</div>
	</div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import axios from 'axios';

export default {
	components: {
		"apexchart": VueApexCharts,
	},

	data() {
		return {
			spinner: false,
			totalActive: 0,
			totalNew: 0,
			totalActiveCompanies: 0,

			lineseries: [],
			linechartOptions: {
				legend: {
					show: false
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					width: 5,
					curve: 'smooth'
				},
				markers: {
					size: 5,
				},
				xaxis: {
					type: 'datetime',
					categories: [],
				},
				tooltip: {
					x: {
						format: 'MMMM'
					},
				}
			},

			pieDeptSeries: [],
			pieDeptChartOptions: {
				labels: [],
				legend: {
					show: false
				},
				responsive: [{
					breakpoint: 480,
					options: {
						chart: {
							width: 200
						},
					}
				}]
			},

			pieSeries: [],
			pieChartOptions: {
				labels: [],
				legend: {
					show: false
				},
				responsive: [{
					breakpoint: 480,
					options: {
						chart: {
							width: 200
						},
					}
				}]
			},

			barseries: [],
			barchartOptions: {
				legend: {
					show: false
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: 'smooth',
				},
				xaxis: {
					type: 'datetime',
					categories: [],
				},
				tooltip: {
					x: {
						format: 'MMMM'
					},
				},
				plotOptions: {
					bar: {
						horizontal: false,    // Set to true if you want horizontal bars
						columnWidth: '200%',   // Adjusts the width of each bar, 100% is the full width
						borderRadius: 5,      // Optional: rounding the corners of bars
						borderWidth: 500      // This increases the border width of the bars
					}
				},
			},
		}
	},

	computed: {
		hasDeptChartData() {
			return Array.isArray(this.pieDeptSeries) && this.pieDeptSeries.length > 0;
		},
		hasAccountAreaData() {
			return Array.isArray(this.barseries) && this.barseries.length > 0;
		},
		hasAccountPieData() {
			return Array.isArray(this.pieSeries) && this.pieSeries.length > 0;
		},
	},

	created() {
		this.fetchAllData()
		console.log(this.token)
	},

	methods: {

		fetchAllData: function () {

			this.spinner = true
			axios.all([
				this.getTotalData(),
				this.getPieData(),
				this.getLineData(),
				this.getBarData(),
				this.getDeptPieData()
			]).then(axios.spread((total, pie, line, bar, dept) => {
				//for total data
				this.totalActive = total.data.data.totalActive
				this.totalNew = total.data.data.totalNew
				this.totalActiveCompanies = total.data.data.totalActiveCompanies

				//for pie data
				const pieData = pie.data.data || {};
				this.pieSeries = pieData.pieSeries || [];
				this.pieChartOptions.labels = pieData.pieLabel ? [...pieData.pieLabel] : [];

				//for bar data
				const barData = bar.data.data || {};
				this.barseries = barData.barseries || [];
				this.barchartOptions.xaxis.categories = barData.barcategories ? [...barData.barcategories] : [];

				//for line data
				const lineData = line.data.data || {};
				this.lineseries = lineData.lineSeries || [];
				this.linechartOptions.xaxis.categories = lineData.lineCat ? [...lineData.lineCat] : [];

				//for dept pie data
				const deptData = dept.data.data || {};
				this.pieDeptSeries = deptData.pieDeptSeries || [];
				this.pieDeptChartOptions.labels = deptData.pieDeptLabel ? [...deptData.pieDeptLabel] : [];

				setTimeout(() => {
					this.spinner = false
				}, 1000);

			}));
		},

		getTotalData: function () {
			return axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}
			}).get('/dashboard/employee/total');
		},

		getDeptPieData: function () {
			return axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}
			}).get('/dashboard/employee/pie/dept');
		},

		getPieData: function () {
			return axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}
			}).get('/dashboard/employee/pie');
		},

		getLineData: function () {
			return axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}
			}).get('/dashboard/employee/line');
		},

		getBarData: function () {
			return axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}
			}).get('/dashboard/employee/bar');
		},

	}
}

</script>

<style lang="css" scoped></style>
